import type { HttpCore } from '../http';

/** Mirrors `frontend/web-ide/src/hooks/useNotifications.ts`'s inline `api.*` calls. */
export interface Notification {
  id: string;
  kind: string;
  payload: Record<string, unknown>;
  deliveredChannels: Record<string, boolean>;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsPage {
  notifications: Notification[];
  unread_count: number;
}

export function createNotificationsModule(core: HttpCore) {
  return {
    list: (params?: { limit?: number }) => core.request<NotificationsPage>('/notifications', { params }),
    markRead: (id: string) => core.request<void>(`/notifications/${encodeURIComponent(id)}/read`, { method: 'PATCH' }),
    markAllRead: () => core.request<void>('/notifications/mark-all-read', { method: 'POST' }),
  };
}

export type NotificationsModule = ReturnType<typeof createNotificationsModule>;
